import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import axios from "axios";
import $ from "jquery";
import { AJAROOT } from "@/common/gdata/global.js";
import queryString from "query-string";
import {
  checkUserLogin,
  getUserIndexData,
  MyToast,
  MyToastShow,
} from "@/jscript/common.js";

import "@/css/user.css";
import rjt from "../../../statics/rjt.png";
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //  myu: "",
      title: "",
      editid: "",
      name: "",
      bgcolor:"",

      selectedbranch: ",",
      branchlist: [],

      postresult: "",

      mytoast: {
        show: false,
      },
    };
  }
  render() {
    const { myusername } = this.props;
    //  let menujson = Menu();
    // console.log(menujson);

    let checkstatus = checkUserLogin(this.props, myusername);

    if (checkstatus != "") return checkstatus;

    return (
      <div
        className="container wrap"
        style={{ height: "100%", paddingBottom: "90px", width: "90%" }}
      >
        <div className="pagetitle">
          <div style={{ float: "left" }}>
            <Link to={"/user/srvcate/list"}>Service Category List</Link>{" "}
            <img src={rjt} style={{ width: "18px", height: "18px" }} />{" "}
            {this.state.title}
          </div>
          <div
            style={{
              float: "right",
            }}
          >
            <div
              style={{}}
              onClick={() => {
                window.history.back(-1);
              }}
            >
              <span className="iconfont fanhui">&#xe625;</span>
            </div>
          </div>
        </div>
        <div className="row textright">
          <div>
            <Link to="/user/srvcate/list">
              <input
                type="button"
                name="button1"
                value="Category List"
                className="add"
              ></input>
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form">
            {/* <div className={this.state.uptype === "1" ? "row" : "nodis"}>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 ">
                姓名:
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 ">
                <input
                  value={this.state.upgzhnickname}
                  onChange={this.changeFirstName.bind(this)}
                />
              </div>
            </div> */}
            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Name:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input
                  value={this.state.name}
                  onChange={this.changeName.bind(this)}
                />
              </div>
            </div>

            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Background Color:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input
                type="color"
                  value={this.state.bgcolor}
                  onChange={this.changeBgcolor.bind(this)}
                />
              </div>
            </div>

            <div className={"row"}>
              <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 textright">
                * Branch:
              </div>
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                {this.state.branchlist.map((item, index) => {
                  return (
                    <div key={"branch" + index} style={{ clear: "both" }}>
                      <input
                        className="checkbox"
                        type="checkbox"
                        value={item.username}
                        checked={
                          this.state.selectedbranch.indexOf(
                            "," + item.username + ","
                          ) >= 0
                            ? true
                            : false
                        }
                        onChange={() => this.selBranch(item.username)}
                      />
                      {"　" + item.lastname}
                    </div>
                  );
                })}

                {/*  <div>
                  <input
                    className="checkbox"
                    type="checkbox"
                    value={myusername}
                    checked={
                      this.state.selectedbranch.indexOf(
                        "," + myusername + ","
                      ) >= 0
                        ? true
                        : false
                    }
                    onChange={() => this.selBranch(myusername)}
                  />
                  {"　" + this.state.zsxm}
                </div> */}
              </div>
            </div>
            <div className="row">
              <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9 textcenter">
                <button className="submit" onClick={() => this.submit()}>
                  Submit
                </button>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textcenter postresult"
                style={{ width: "70%", marginTop: "10px" }}
              >
                {this.state.postresult}
              </div>
            </div>
          </div>
        </div>
        {this.state.mytoast.show ? MyToast(this.state.mytoast) : null}
      </div>
    );
  }
  changeBgcolor(e) {
    let val = e.target.value;
    this.setState({
      bgcolor: val,
    });
  }
  changeName(e) {
    let val = e.target.value;
    this.setState({
      name: val,
    });
  }
  selBranch(username) {
    let selectedbranch = this.state.selectedbranch;
    if (selectedbranch.indexOf("," + username + ",") >= 0)
      selectedbranch = selectedbranch.replace("," + username + ",", ",");
    else {
      selectedbranch = selectedbranch + username + ",";
    }

    this.setState({
      selectedbranch: selectedbranch,
    });
  }

  submit() {
    const { myusername, ukey } = this.props;

    //console.log(this.state.pages);
    // document.getElementById("result2").style.color = "#000000";
    //

    this.setState({
      postresult: "Waiting....",
    });
    // document.getElementById("result2").innerHTML = "正在提交....";
    let dianscope = this.state.selectedbranch;
    const postdata = {
      uid: myusername,
      editid: this.state.editid,
      name: this.state.name,
      bgcolor: this.state.bgcolor,
      dianscope: dianscope,
    };

    const this2 = this;
    var error = "";

    if (this.state.name === "") error = "Please fill in name";
    else if (dianscope == ",") error = "Please select branch";

    //document.getElementById("result2").style.color = "red";
    if (error !== "") {
      this.setState({
        postresult: error,
      });
    } else {
      $.ajax({
        type: "POST",
        dataType: "json",
        url:
          AJAROOT +
          "/postaja/savexx.aspx?action=saveservicecate&u=" +
          myusername +
          "&ukey=" +
          encodeURIComponent(ukey) +
          "",
        data: JSON.stringify(postdata),
      })
        .done(function (res) {
          var r = res.r;

          if (r === 1) {
            //  this.postresult = "登陆成功！";
            MyToastShow(
              this2,
              2,
              "Successfully! ",
              150,
              80,
              "success",
              "addbranch"
            );
            this2.setState({
              postresult: "Successfully! ",
            });

            this2.props.history.push("/user/srvcate/list");
          } else {
            MyToastShow(this2, 2, res.s, 200, 120, "fail", "addsrvcate");
            //document.getElementById("result2").style.color = "red";
            this2.setState({
              postresult: res.s,
            });

            //  document.getElementById("result2").innerHTML = msg;
          }
        })
        .fail(function (xhr, textStatus, errorThrown) {});
    }
  }

  componentDidMount() {
    const { myusername, ukey } = this.props;
    var { id } = queryString.parse(this.props.location.search);
    if (id == undefined) id = "";

    var title = "Add Service Category";

    if (id != "") {
      title = "Edit Service Category";
    }
    document.title = title;
    this.setState({
      title: title,
      editid: id,
    });

    // getUserIndexData(this, myusername, ukey);
    if (id != "") this.getData(myusername, encodeURIComponent(ukey), id);
    this.getBranchData(myusername, encodeURIComponent(ukey), id);
    //  this.getData(myusername, ukey);
    //  MyToastShow(this, 200, "Successfully! ", 150, 80, "success", "addgroup");
  }

  getData(myusername, ukey, id) {
    var geturl =
      AJAROOT +
      "/getaja/xx.aspx?u=" +
      myusername +
      "&ukey=" +
      ukey +
      "&action=servicecateinfo&id=" +
      id +
      "";

    axios.get(geturl).then((res) => {
      const result = res.data;
      console.log(result);
      let dianscope = result.dianscope;
      //  let groupright = eval(result.groupright);

      this.setState({
        editid: result.id,
        selectedbranch: dianscope,
        name: result.name,
        bgcolor:result.bgcolor
      });

      // this.setState({}); /**/
    });
  }
  getBranchData(myusername, ukey, editid) {
    var geturl =
      AJAROOT +
      "/getaja/xx.aspx?u=" +
      myusername +
      "&ukey=" +
      ukey +
      "&action=branchlist";

    axios.get(geturl).then((res) => {
      const result = res.data;
      let selectedbranch = ",";
      result.list.forEach((element, j) => {
        selectedbranch = selectedbranch + element.username + ",";
      });
      //  let groupright = eval(result.groupright);
      if (editid == "") {
        this.setState({
          selectedbranch: selectedbranch,
          branchlist: result.list,
        });
      } else {
        this.setState({
          //  selectedbranch: selectedbranch,
          branchlist: result.list,
        });
      }
      // this.setState({}); /**/
    });
  }
  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  componentWillUpdate() {}
  componentDidUpdate() {}
}

const mapStateToProps = (state) => {
  return {
    myusername: state.getIn(["gdata", "username"]),
    myusertype: state.getIn(["gdata", "usertype"]),
    myusergrade: state.getIn(["gdata", "usergrade"]),
    ukey: state.getIn(["gdata", "ukey"]),
    zsxm: state.getIn(["gdata", "zsxm"]),
  };
};

export default connect(mapStateToProps, null)(Index);
